module.exports = __webpack_public_path__ + "static/group-trim-af3dcc3fca03778ff0fd84f9b118483f.png";